// extracted by mini-css-extract-plugin
export default {"root":"createAccount_root__kIDb4"};